/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Image_Export_Select_Folder_TitleInputs */

const en_image_export_select_folder_title = /** @type {(inputs: Image_Export_Select_Folder_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Export Images - Select Folder`)
};

const fr_image_export_select_folder_title = /** @type {(inputs: Image_Export_Select_Folder_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exporter les images - Selectionner un dossier`)
};

const de_image_export_select_folder_title = /** @type {(inputs: Image_Export_Select_Folder_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bilder exportieren – Ordner auswählen`)
};

const it_image_export_select_folder_title = /** @type {(inputs: Image_Export_Select_Folder_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esporta immagini - Seleziona cartella`)
};

const ru_image_export_select_folder_title = /** @type {(inputs: Image_Export_Select_Folder_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Экспорт изображений - Выберите папку`)
};

const es_image_export_select_folder_title = /** @type {(inputs: Image_Export_Select_Folder_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exportar imágenes - Seleccionar carpeta`)
};

const zh_cn2_image_export_select_folder_title = /** @type {(inputs: Image_Export_Select_Folder_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`导出图像 - 选择文件夹`)
};

const ja_image_export_select_folder_title = /** @type {(inputs: Image_Export_Select_Folder_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`画像をエクスポート - フォルダを選択`)
};

const hi_image_export_select_folder_title = /** @type {(inputs: Image_Export_Select_Folder_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`इमेज एक्सपोर्ट करें - फ़ोल्डर चुनें`)
};

const pt_pt2_image_export_select_folder_title = /** @type {(inputs: Image_Export_Select_Folder_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exportar imagens - Selecionar pasta`)
};

/**
* | output |
* | --- |
* | "Export Images - Select Folder" |
*
* @param {Image_Export_Select_Folder_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const image_export_select_folder_title = /** @type {((inputs?: Image_Export_Select_Folder_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Image_Export_Select_Folder_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_image_export_select_folder_title(inputs)
	if (locale === "de") return de_image_export_select_folder_title(inputs)
	if (locale === "it") return it_image_export_select_folder_title(inputs)
	if (locale === "ru") return ru_image_export_select_folder_title(inputs)
	if (locale === "es") return es_image_export_select_folder_title(inputs)
	if (locale === "zh-CN") return zh_cn2_image_export_select_folder_title(inputs)
	if (locale === "ja") return ja_image_export_select_folder_title(inputs)
	if (locale === "hi") return hi_image_export_select_folder_title(inputs)
	if (locale === "pt-PT") return pt_pt2_image_export_select_folder_title(inputs)
	return en_image_export_select_folder_title(inputs)
});